import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";

import Moment from "react-moment";

import lastLogIcon from '../../../theme/assets/svg/tc_cab_settings_last_log_icon.svg';
import ipIcon from '../../../theme/assets/svg/tc_cab_settings_ip_icon.svg';
import deviceIcon from '../../../theme/assets/svg/tc_cab_settings_device_icon.svg';
import {useDispatch, useSelector} from "react-redux";
// import {toast} from "react-toastify";
import {logoutOthers} from "../../../store/cabinet/action";




const CabinetSettingsProtection = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const lastLog = useSelector(store => store.cabinet.lastLog);
    const logoutOthersStatusStarted = useSelector(store => store.cabinet.logoutOthersStatusStarted);

    const successHandler = () =>{
        // toast('Вы успешно вышли со всех устройств, кроме текущего!')
    }

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC} ${Styles.perspective3dXl}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl} ${Styles.rotate3dRightXl}`}>
                    <div className={`${Styles.cardBox}`}>
                        <div className={`${Styles.contentBoxTitle}`}>{t('Безопасность')}</div>
                        <div className={`${Styles.protectionWrap}`}>
                            <div className={`${Styles.protectionRow}`}>
                                <div className={`${Styles.protectionRowIconWrap}`}>
                                    <img src={lastLogIcon} alt={t('Последний вход')}/>
                                </div>
                                <div className={`${Styles.protectionRowPos}`}>
                                    <div className={`${Styles.protectionRowPosName}`}>{t('Последний вход')}</div>
                                    <div className={`${Styles.protectionRowPosValue}`}>{lastLog?.last_login?.logged_in_at ? <Moment format="DD MMM YYYY, HH:mm">{lastLog?.last_login?.logged_in_at}</Moment> : '...'}</div>
                                </div>
                            </div>
                            <div className={`${Styles.protectionRow}`}>
                                <div className={`${Styles.protectionRowIconWrap}`}>
                                    <img src={ipIcon} alt={t('IP адрес')}/>
                                </div>
                                <div className={`${Styles.protectionRowPos}`}>
                                    <div className={`${Styles.protectionRowPosName}`}>{t('IP адрес')}</div>
                                    <div className={`${Styles.protectionRowPosValue}`}>{lastLog?.last_login?.ip_address || '...'}</div>
                                </div>
                            </div>
                            <div className={`${Styles.protectionRow}`}>
                                <div className={`${Styles.protectionRowIconWrap}`}>
                                    <img src={deviceIcon} alt={t('Устройство')}/>
                                </div>
                                <div className={`${Styles.protectionRowPos}`}>
                                    <div className={`${Styles.protectionRowPosName}`}>{t('Устройство')}</div>
                                    <div className={`${Styles.protectionRowPosValue}`}>{lastLog?.last_login?.browser && lastLog?.last_login?.platform ? `${lastLog?.last_login?.browser} / ${lastLog?.last_login?.platform}` : '...'}</div>
                                </div>
                            </div>
                        </div>
                        <div
                            className={`${Styles.logOutBtn}`}
                            onClick={()=>{
                                if (!logoutOthersStatusStarted) {
                                    dispatch(logoutOthers(successHandler))
                                }
                            }}
                        >
                            {t('Выйти со всех устройств, кроме текущего')}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetSettingsProtection;